(function () {
    var i = 0;
    jQuery('.widget').each(function (index, e) {
        window.setTimeout(function () {
            jQuery(e).addClass('active');
        }, i * 100);
        i++;
    });

    if (window.location.pathname !== '/user/edit' && window.location.pathname !== '/user/create' && window.location.pathname !== '/u-save-share/user/create') return;

    var title = $('#title').selectize();

    title[0].selectize.setValue($('input[name="title_code"]').val());

    $.get(`/static/datasets/countries`).done(function (countries) {
        populateDropdown(countries);
    });

    function populateDropdown(countries) {
        var country = $('#country').selectize({
            valueField: 'code',
            labelField: 'name',
            searchField: 'name',
            sortField: 'name',
            selectOnTab: true,
            options: countries,
        });

        country[0].selectize.setValue($('input[name="country_code"]').val());
    }
})();
